const imp = () => import(/* webpackChunkName: "loadSprite_message_surface"*/  "../sprite/loadSprite_message_surface");

const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Add-people": imp,
  "Icon-Android": imp,
  "Icon-Apple": imp,
  "Icon-Don't-disturb": imp,
  "Icon-Graffiti": imp,
  "Icon-Hang-up": imp,
  "Icon-link02": imp,
  "Icon-I'm-talking": imp,
  "Icon-Location-session": imp,
  "Icon-Message-picture": imp,
  "Icon-Message-voice": imp,
  "Icon-News-video": imp,
  "Icon-Put-it-away": imp,
  "Icon-Recording": imp,
  "Icon-Refuse-to-accept": imp,
  "Icon-Switch-cameras": imp,
  "Icon-Video-off-check": imp,
  "Icon-Voice-conversion": imp,
  "Icon-Video-off": imp,
  "Icon-Voice-duration": imp,
  "Icon-Voice-input": imp,
  "Icon-Voice-off-select": imp,
  "Icon-Voice-off": imp,
  "Icon-Wait-for-the-connection": imp,
  "Icon-answer-the-phone": imp,
  "Icon-iCloud": imp,
  "Icon-on-speakerphone": imp,
  "Icon-photograph": imp,
  "Icon-position": imp,
  "browser": imp,
  "client": imp,
  "mobile-browser": imp,
  "win-client": imp,
  "Icon-Mail-list-o2": imp,
  "Icon-Documentation": imp,
  "Icon-Groupannouncement": imp,
  "Icon-topic-of-conversation": imp,
  "Icon-deallater-o": imp,
  "Icon-Solitaire-0": imp,
}
export default loadMap;